<template>
  <div class="bg-FFFFFF">
    <!-- -1当天无数据 0当天有数据且没有未吃饭记录 1当天有数据且存在未吃饭记录 -->
    <!-- 0 正常 1 不正常 -->
    <common-slide-calendar
      class="bg-FFFFFF"
      :default-date="new Date(dateToTime(defaultDate, '/'))"
      @getDate="methodGetDate"
      @changeCalendarType="changeCalendarType"
      @onTransitionEnd="onTransitionEnd"
      :with-status="true"
      :status-list="dateExceed ? [] : statusList"
      timeFormat="YYYYMMDD"
    >
      <div
        slot="title"
        class="p-16-0 bb fb fb-cross-center fb-main-between c-171A1D font-28 p-0-16 bb"
      >
        <span>{{
          timeFormat(new Date(dateToTime(startDate, '/')), 'YYYY.MM')
        }}</span>
      </div>
    </common-slide-calendar>
    <template v-if="!dateExceed">
      <div
        class="bg-F9F9F9 p-12-0 pl-12 pr-20 m-0-16 font-28 bd-radio-4"
        v-if="askForLeave.length"
      >
        <div
          class="fb fb-main-between fb-cross-center"
          :class="{ bt: index > 0 }"
          v-for="(item, index) in askForLeave"
          @click="handlerRouter(item)"
          :key="index"
        >
          <div class="fb fb-cross-baseline font-34">
            <span class="iconfont c-FF9F00 mr-7">&#xe688;</span>
            <div>
              <div class="fb fb-cross-center">
                <span class="c-171A1D ff-medium lh-24 mb-4"
                  >{{ item.leaveTypeName }}
                </span>
                <span class="ml-4 c-171A1D-60"
                  >({{ methodTransfromTime(item)[1] }})</span
                >
              </div>
              <p class="font-26 c-171A1D-56">{{
                methodTransfromTime(item)[0]
              }}</p>
            </div>
          </div>
          <span class="iconfont font-28 c-171A1D-40">&#xe66b;</span>
        </div>
      </div>
      <div v-if="list.length" class="pl-16 pr-6 bg-FFFFFF pt-24">
        <common-step
          :show-line="ix === 0"
          :icon="1"
          class=""
          v-for="(it, ix) in list"
          :key="ix"
        >
          <div slot="title">
            <span class="font-34 lh-18 ff-medium"
              >{{ MEAL_TEXT[it.mealType] }}&nbsp;{{
                timeFormat(new Date(it.mealTime), 'hh:mm')
              }}</span
            >
          </div>
          <div slot="main" class="pl-16 pb-50 font-30 c-111F2C-60 pt-8">
            <span :class="{ 'c-FF5219': [3].includes(it.mealStatus) }">{{
              MEAL_STATUS[it.mealStatus]
            }}</span>
          </div>
        </common-step>
      </div>
      <div v-else class="noData fb fb-col pt-20">
        <i class="iconfont font-140 c-171A1D-12">&#xe68b;</i>
        <p class="font-26 c-171A1D-40">当天暂无就餐记录</p>
      </div>
    </template>
    <div
      class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
      v-if="dateExceed"
    >
      <div class="fb fb-col c-171A1D-40">
        <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
        <p class="font-26 mt-16 text-center mt-16">超出可查看的统计日期范围</p>
      </div>
    </div>
  </div>
</template>
<script>
import commonSlideCalendar from './commonSlideCalendar'
import commonStep from './commonStep'
import mixin from '../mixin'
import {} from '@/utils/mcSdkUtils'
import {
  unitDayTime,
  timeFormat,
  dateToTime,
  debounce,
  getWeekRange
} from '@/utils/comUtils'
import API from '../api'
export default {
  mixins: [mixin],
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    date: {
      type: String,
      default: timeFormat(new Date(), 'YYYY/MM/DD')
    }
  },
  components: {
    commonSlideCalendar,
    commonStep
  },
  computed: {},
  watch: {},
  data() {
    return {
      timeFormat,
      dateToTime,
      MEAL_TEXT: {
        1: '午餐',
        2: '晚餐'
      },
      MEAL_STATUS: {
        1: '待确认',
        2: '已吃饭',
        3: '未吃饭',
        4: '请假'
      },
      time: '',
      noData: require('../assets/images/noData.png'),
      normal: require('../assets/images/normal.png'),
      list: [],
      askForLeave: [],
      statusList: [],
      selectedDate: this.date.replace(/\//gi, ''),
      calendarType: 0,
      defaultDate: this.date,
      startDate: timeFormat(getWeekRange(this.date).monday, 'YYYYMMDD'),
      endDate: timeFormat(getWeekRange(this.date).sunday, 'YYYYMMDD'),
      dateExceed: false
    }
  },
  methods: {
    // 跳转页面
    handlerRouter(item) {
      this.$router.push({
        path: '/leave/detail',
        query: {
          leaveId: item.leaveId
        }
      })
    },
    // 是否滑动
    onTransitionEnd({ date, calendarType, startDate, endDate, exceed }) {
      this.calendarType = calendarType
      this.startDate = startDate
      this.endDate = endDate
      this.dateExceed = exceed
      if (exceed) {
        return
      }
      console.log(333, date)
      if (date.slice(0, 6) !== this.selectedDate.slice(0, 6)) {
        this.selectedDate = date
      }
      debounce(this.getAttendanceCalendar)()
    },
    // 切换周/月历
    changeCalendarType({
      date,
      calendarType,
      startDate,
      endDate,
      exceed
    } = {}) {
      console.log(555, date)
      this.selectedDate = date
      this.startDate = startDate
      this.endDate = endDate
      console.log(2222, exceed)
      this.dateExceed = exceed
      this.calendarType = calendarType
      debounce(this.getAttendanceCalendar)()
    },
    getAttendanceCalendar(date, type) {
      console.log(1111)
      let _yearMonth = (this.selectedDate + '').slice(0, -2)
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}` ||
        +_yearMonth > +`${year}${month}`
      ) {
        return false
      }
      const { memberId } = this.student
      API.getMealDimDayStatus({
        ...this.commonParams,
        startDate: this.startDate,
        endDate: this.endDate,
        memberId: memberId
      })
        .then(res => {
          this.statusList = res || []
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 时间格式化
    methodTransfromTime(time) {
      let _time = []
      if (+time.leaveDurationUnit === 2) {
        let _start = new Date(time.start.replace(/-/gi, '/'))
        let _end = new Date(time.end.replace(/-/gi, '/'))
        let _unitDayTime = unitDayTime(+_start, +_end)
        let _seg = ((_end - _start) / (24 * 60 * 60 * 1000)).toFixed(1)
        _time[0] = `${_unitDayTime[0]}～${_unitDayTime[1]}`
        _time[1] = `${_seg}天`
      } else {
        let _start = time.start.replace(/-/g, '.')
        let _end = time.end.replace(/-/g, '.')
        if (time.period > 60) {
          const _HOURS = (time.period / 60).toFixed(1)
          _time[0] = `${_start}～${_end}`
          _time[1] = `${_HOURS}小时`
        } else {
          _time[0] = `${_start}～${_end}`
          _time[1] = `${time.period}分钟`
        }
      }
      return _time
    },
    // 判断是否有打卡记录，以便显示是否需要显示打卡机
    methodGetDate(date) {
      this.selectedDate = date
      this.time = date
      this.$emit('change', date)
    },
    getUserAttenceReport() {
      API.getMealStudentMealRecord({
        ...this.commonParams,
        dimDay: this.selectedDate,
        memberId: this.student.memberId
      })
        .then(res => {
          this.askForLeave = res.leaveRecordList || []
          this.list = res.studentMealInfoList || []
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    }
  },
  mounted() {
    this.$watch('selectedDate', {
      immediate: true,
      handler() {
        debounce(this.getUserAttenceReport)()
        debounce(this.getAttendanceCalendar)()
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.noData {
  height: 360px;
  text-align: center;
  img {
    margin: 0 auto;
    margin-top: 45px;
    height: 60px;
    width: 60px;
  }
  p {
    margin-top: 16px;
    text-align: center;
    color: rgba(25, 31, 37, 0.4);
  }
}
</style>
